import { render } from "./verticalBorders.vue?vue&type=template&id=50e809a2"
import script from "./verticalBorders.vue?vue&type=script&lang=js"
export * from "./verticalBorders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__